"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(2),
    "& + $root": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    }
  },
  header: {
    marginBottom: theme.spacing(2)
  },
  body: {},
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "normal",
    fontWeight: "bold",
    letterSpacing: 0
  }
}));

const PrimusSectionPreview = ({
  titleHidden,
  title,
  children
}) => {
  const classes = useStyles();

  if (titleHidden) {
    return _react.default.createElement("section", {
      className: classes.root
    }, _react.default.createElement("div", {
      className: classes.body
    }, children));
  }

  return _react.default.createElement("section", {
    className: classes.root
  }, title && _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title)), _react.default.createElement("div", {
    className: classes.body
  }, children));
};

var _default = PrimusSectionPreview;
exports.default = _default;
module.exports = exports.default;